import type { StructuredOutputRerunTarget } from "@/types/structured-output-rerun";

export type { StructuredOutputRerunTarget };

/**
 * Parse dashboard SO rerun input:
 * - one target per line
 * - optional `,call_id` after case_id on the same line for a specific call
 */
export function parseStructuredOutputRerunTargets(
  raw: string,
): StructuredOutputRerunTarget[] {
  const targets: StructuredOutputRerunTarget[] = [];
  const seen = new Set<string>();

  for (const line of raw.split(/\r?\n/)) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith("#")) continue;

    const commaIdx = trimmed.indexOf(",");
    let case_id: string;
    let call_id: string | undefined;

    if (commaIdx === -1) {
      case_id = trimmed;
    } else {
      case_id = trimmed.slice(0, commaIdx).trim();
      const callPart = trimmed.slice(commaIdx + 1).trim();
      call_id = callPart || undefined;
    }

    if (!case_id) continue;

    const dedupeKey = call_id ? `${case_id}\0${call_id}` : case_id;
    if (seen.has(dedupeKey)) continue;
    seen.add(dedupeKey);

    targets.push(call_id ? { case_id, call_id } : { case_id });
  }

  return targets;
}

/** URL/query params: comma-separated case ids (latest call each). */
export function formatUrlCaseIdsParam(targets: StructuredOutputRerunTarget[]): string {
  return targets.map((t) => t.case_id).join(",");
}
